export default __webpack_public_path__ + "static/ПП КХ PLANRETACARD-AURACARD для ТРК Пр1 к Пр2109-62bf5556d0edf2a6417f493a700d8953.pdf";